import { useEffect, useState } from 'react';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

interface MaintenanceModeState {
  isMaintenanceMode: boolean;
  loading: boolean;
  setMaintenanceMode: (enabled: boolean) => Promise<void>;
}

export function useMaintenanceMode(): MaintenanceModeState {
  const [isMaintenanceMode, setIsMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(db, 'settings', 'app');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setIsMaintenance(snap.exists() ? (snap.data().maintenanceMode ?? false) : false);
        setLoading(false);
      },
      (_err) => {
        // Permission denied or network error — default to no maintenance
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  const setMaintenanceMode = async (enabled: boolean) => {
    const ref = doc(db, 'settings', 'app');
    await setDoc(ref, { maintenanceMode: enabled }, { merge: true });
  };

  return { isMaintenanceMode, loading, setMaintenanceMode };
}
